import { debounce } from "lodash";
import Plyr from "plyr";

export function init(pageVideoSection) {
  const wrapper = pageVideoSection.querySelector(".video-wrapper");
  let videoId;
  if (window.innerWidth < 640) {
    videoId = pageVideoSection.querySelector("video[id^='player-mobile']").id;
  } else {
    videoId = pageVideoSection.querySelector("video[id^='player-desktop']").id;
  }

  if (wrapper) {
    initPlyr(videoId, wrapper);
  }

  window.addEventListener(
    "resize",
    debounce(() => {
      let newVideoId;
      if (window.innerWidth < 640) {
        newVideoId = pageVideoSection.querySelector(
          "video[id^='player-mobile']"
        ).id;
      } else {
        newVideoId = pageVideoSection.querySelector(
          "video[id^='player-desktop']"
        ).id;
      }
      if (newVideoId !== videoId) {
        initPlyr(newVideoId, wrapper);
      }
    }, 200)
  );
}

function initPlyr(videoId, wrapper) {
  if (!wrapper) return;
  const iconUrl = wrapper.dataset.iconUrl;
  /* Add option to have a custom icon */
  const player = new Plyr(`#${videoId}`, {
    //  iconUrl: `https://${iconUrl}`
  });
  wrapper.classList.remove("opacity-0");
}
